module.exports = __webpack_public_path__ + "img/animals_dog.0cc59433.svg";